import { defineStore } from 'pinia'
import api, { sanctumApi } from '@/services/api'
import router from '@/router'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: localStorage.getItem('token') || null,
  }),

  getters: {
    isAuthenticated: (state) => !!state.token,
    
    isSuperAdmin: (state) => {
      if (!state.user?.role_assignments) return false
      return state.user.role_assignments.some(
        assignment => assignment.role.name === 'SUPER_ADMIN'
      )
    },
  },

  actions: {
    async login(credentials) {
      try {
        await sanctumApi.get('/sanctum/csrf-cookie')
        
        const { data } = await api.post('/auth/login', credentials)
        
        this.setToken(data.token)
      
        
        await this.fetchUser()
        
        
        router.push('/admin/translations')
        
        return data
      } catch (error) {

        this.logout()
        throw error
      }
    },

    async fetchUser() {
      try {
        const { data } = await api.get('/current-user')
        this.user = data
      } catch (error) {
        this.logout()
        throw error
      }
    },

    setToken(token) {
      this.token = token
      localStorage.setItem('token', token)
    },

    logout() {
      this.user = null
      this.token = null
      localStorage.removeItem('token')
      router.push({ name: 'login' })
    },
  },
})